import { NgClass, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RouterOutlet } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TermsConfirmationDialogComponent } from './components/terms/terms-dialog.component';
import { CommonService } from './services/common.service';
import { FooterComponent } from './shared/footer/footer.component';
import { HeaderComponent } from './shared/header/header.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, RouterOutlet, HeaderComponent, SpinnerComponent, FooterComponent ],
})
export class AppComponent implements OnInit, OnDestroy {
  title = '';
  isLoading$: Observable<boolean> = new Observable<boolean>();
  loaderMessage$: Observable<string> = new Observable<string>();
  logoutUrl: string = environment.SSO_LOGOUT_URL;
  recordedFilesTemplate!: TemplateRef<Element>;

  constructor(
    public comSvc: CommonService,
    private bnNgIdleService: BnNgIdleService,
    public dialog: MatDialog,
    private fb: FormBuilder
  ) {
    this.isLoading$ = this.comSvc.isLoaderEnabled.asObservable();
    this.loaderMessage$ = this.comSvc.loaderMessage.asObservable();
  }

  ngOnInit() {
    this.comSvc.securityPledgeSign.subscribe((value) => {
      if (value === "0") {
        this.openConfirmationDialog();
      }
    });

    this.bnNgIdleService.startWatching(3600).subscribe((isTimeout: boolean) => {
      if (isTimeout) {
        this.comSvc.logOut();
        this.bnNgIdleService.stopTimer();
      }
    });
  }

  ngOnDestroy() {
    this.bnNgIdleService.stopTimer();
    this.comSvc.loaderMessage.unsubscribe();
    this.comSvc.isLoaderEnabled.unsubscribe();
  }

  openConfirmationDialog() {
    this.dialog.open(TermsConfirmationDialogComponent, {
      width: '600px',
      disableClose: true,
    });
  }
}